module.exports = __webpack_public_path__ + "img/user2.309f5a87.svg";